import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  content: {
    margin: `${theme.spacing(3)}px ${-theme.spacing(1)}px`,
  },
  openModalBtn: {
    cursor: 'pointer',
    color: '#78909C',
    '& strong': {
      color: '#072D83',
      fontWeight: 600,
    },
  },
  rgModalContent: {
    display: 'flex',
    gap: theme.spacing(5),
    '& section': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      '& p': {
        display: 'flex',
        alignItems: 'flex-end',
        fontSize: 24,
        fontWeight: 600,
        lineHeight: '20px',
        color: '#0D47A1',
        marginBottom: theme.spacing(2.5),
      },
      '& span': {
        fontSize: 20,
        lineHeight: '20px',
        marginLeft: theme.spacing(1),
      },
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'center',
      '& section': {
        '& p': {
          marginBottom: 0,
        },
      },
      '& svg': {
        width: '100%',
        height: 'fit-content',
      },
    },
  },
  helperText: {
    fontSize: 10,
    color: '#072D83',
  },
  subtitle: {
    color: '#072D83',
    fontWeight: 600,
    fontSize: 24,
    marginBottom: theme.spacing(1),
    lineHeight: 1.2,
  },
  subtitleDescription: {
    color: '#546E7A',
    fontSize: 16,
  },
  selfieModalContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(5),
    textAlign: 'center',
    '& p': {
      fontSize: 24,
      fontWeight: 600,
      color: '#0D47A1',
      marginBottom: theme.spacing(2.5),
    },
    '& svg': {
      marginBottom: -64,
    },
    '& img': {
      maxWidth: '100%',
    },
    [theme.breakpoints.down('md')]: {
      '& svg': {
        width: '100%',
        maxWidth: 320,
        height: 'fit-content',
      },
    },
  },
  cnhModalContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    '& p': {
      fontSize: 24,
      fontWeight: 600,
      color: '#0D47A1',
    },
    '& img': {
      maxWidth: '100%',
    },
    [theme.breakpoints.down('md')]: {
      '& svg': {
        width: '100%',
        height: 'fit-content',
      },
    },
  },
}));
